import CDS from "design-system";
import PersonalEmailPortalAccessSettings from "features/Settings/PersonalEmailPortalAccess";
import { useNavbar } from "hooks/useNavbar";
import AppPage from "layouts/AppPage";
import InnerSidebar from "layouts/InnerSidebar";
import { useEffect } from "react";

export default function NewHireExperienceSettingsPage() {
  const { setBackLocationPath, setBackLocationName, setPageTitle } = useNavbar();

  useEffect(() => {
    setPageTitle("New Hire Experience");
    return () => {
      setBackLocationPath(null);
      setBackLocationName(null);
      setPageTitle(null);
    };
  }, [setBackLocationPath, setBackLocationName, setPageTitle]);

  return (
    <AppPage>
      <InnerSidebar>
        <CDS.Heading14 mb="8" color="fg.subtle">
          New Hire Experience
        </CDS.Heading14>
        <PersonalEmailPortalAccessSettings />
      </InnerSidebar>
    </AppPage>
  );
}
